import { render, staticRenderFns } from "./DrinkFrequency.vue?vue&type=template&id=02cc69ba&scoped=true&"
import script from "./DrinkFrequency.vue?vue&type=script&lang=ts&"
export * from "./DrinkFrequency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cc69ba",
  null
  
)

export default component.exports